const state = {
  demoUserData: [
    {
      "id": 1,
      "usuario": "demo",
      "nombre": "Usuario Demo",
      "genero": "h",
      "password": "demo1234",
      "perfil": "Administrador"
    }
  ],
};

const getters = {
  demoUser: state => state.demoUserData.find(user => user.usuario == "demo"),
  demoUsers: state => state.demoUserData,
};

const actions = {
  getUsuarioDemoByID: (state, id) => state.demoUserData.find(user => user.id == id),
};

export default {
  state,
  getters,
  actions
}